import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

import dumb3 from "./images/dumb3.png";
import { SearchBar } from "./";

const Navbar = () => (
  <Stack direction="row" alignItems="center" p={2} sx={{ position:  "sticky", background: '#000', top: 0, justifyContent: "space-between" }}>
    <Link to="/" style={{ display: "flex", alignItems: "center" }}>
      <img src={dumb3} alt="logo" height={70} width = {180} />
    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar;